/**
 * v38.8 — Tenant "Hospital workspace not configured" screen.
 *
 * Rendered in two situations:
 *   1) The SPA is loaded under an unrecognised tenant subdomain (e.g.
 *      sushruta.klickniramaya.com) whose slug has no live DNS/workspace yet
 *      — handled in App.js when the /api/tenant/by-slug bootstrap fails.
 *   2) The user is on the root domain (klickniramaya.com) and selects a
 *      hospital from the dropdown whose `dns_configured` flag is false.
 *
 * Single shared component to keep both flows pixel-identical.
 */
export const TenantNotConfigured = ({
  slug,
  hostname,
  hospitalName,
  onContinue,
  hideContinue = false,
}) => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0f172a',
        color: '#fff',
        fontFamily: 'system-ui, sans-serif',
        padding: 24,
      }}
      data-testid="tenant-not-configured"
    >
      <div style={{ maxWidth: 540, textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>🏥</div>
        <h1 style={{ fontSize: 22, margin: '0 0 8px' }}>Hospital workspace not configured</h1>
        <p style={{ opacity: 0.7, fontSize: 14, lineHeight: 1.55, margin: '0 0 22px' }}>
          {hospitalName ? (
            <>
              <strong>{hospitalName}</strong> does not yet have its dedicated subdomain
              {slug ? <> (<code style={{ background: 'rgba(255,255,255,0.1)', padding: '2px 6px', borderRadius: 4 }}>{slug}.klickniramaya.com</code>)</> : null} live.
              Please ask your super-admin to configure DNS and flip the&nbsp;
              <em>DNS / Subdomain Live</em> switch on the Hospital record.
            </>
          ) : (
            <>
              This domain (<strong>{hostname}</strong>) is reserved for a tenant whose URL slug is&nbsp;
              <code style={{ background: 'rgba(255,255,255,0.1)', padding: '2px 6px', borderRadius: 4 }}>{slug}</code>,
              but no active hospital was found matching that slug, code, or name.
            </>
          )}
        </p>
        {!hideContinue && onContinue && (
          <button
            onClick={onContinue}
            data-testid="tenant-bypass-btn"
            style={{
              background: 'linear-gradient(135deg, #10b981, #84cc16)',
              color: '#0f172a',
              border: 0,
              padding: '11px 22px',
              borderRadius: 10,
              fontWeight: 700,
              cursor: 'pointer',
              fontSize: 14,
              marginBottom: 20,
            }}
          >
            Continue to Platform Login →
          </button>
        )}
        <p style={{ opacity: 0.5, fontSize: 12, lineHeight: 1.5 }}>
          Log in as super-admin, open <em>Super Admin → Hospitals → Edit</em> and set this hospital&apos;s
          <strong> URL Slug </strong>
          {slug ? <>to <code>{slug}</code></> : null} and enable
          <strong> DNS / Subdomain Live</strong>, then reload this page.
        </p>
      </div>
    </div>
  );
};

export default TenantNotConfigured;
